export { default as profileMagazineItemM } from '@handlebars/mobile/profile-magazine-item.hbs';
export { default as profileBrunchBookCoverItem } from '@handlebars/profile-brunchbook-cover-item.hbs';
export { default as profileBrunchBookItem } from '@handlebars/profile-brunchbook-item.hbs';
export { default as profileMagazineItem } from '@handlebars/profile-magazine-item.hbs';
export { default as profileRecommendWriters } from '@handlebars/profile-recommend-writers.hbs';
